import { EuiCollapsibleNavBeta } from "@inscopix/ideas-eui";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { memo } from "react";

export const HeaderNavProfile = memo(function HeaderNavProfile() {
  const routeMap = useRouteMapContext((s) => s.routeMap);

  return (
    <EuiCollapsibleNavBeta.Item
      title="Profile"
      icon="user"
      onClick={() => {
        // Navigate to the organization page
        routeMap["SETTINGS"].navigateTo();
      }}
    />
  );
});
